import QTable from 'quasar/src/components/table/QTable.js';

export const adminCouponIndexPageTableColumn = (): QTable['columns'] => [
  {
    name: 'title',
    field: 'title',
    label: 'عنوان تخفیف',
    align: 'center',
    classes: 'max-width-200'
  },
  {
    name: 'code',
    field: 'code',
    label: 'کد تخفیف',
    align: 'center'
  },
  {
    name: 'status',
    field: 'status',
    label: 'وضعیت',
    align: 'center'
  },
  {
    name: 'type',
    field: 'type',
    label: 'نوع کمپین',
    align: 'center'
  },
  {
    name: 'special_offer',
    field: 'special_offer',
    label: 'پیشنهاد ویژه',
    align: 'center'
  },
  {
    name: 'usage_count_limit',
    field: 'usage_count_limit',
    label: 'حداکثر استفاده',
    align: 'center'
  },
  {
    name: 'used_count',
    field: 'used_count',
    label: 'استفاده شده',
    align: 'center'
  },
  {
    name: 'actions',
    field: 'actions',
    label: 'عملیات',
    align: 'center'
  }
]
